import React from 'react'
import { Checkbox, Form } from '@surecompanies/core_components'
import {
  PaymentAssignmentStatusId,
  type PaymentStatus,
} from '../../Utils/types'
import {
  StatusUpdateFormKey,
  StatusUpdateFormKeyLabels,
} from '../statusUpdate.type'
import type { PaymentAssignmentRolePolicy } from '../../Utils/rolePolicy'
import { PaymentSubmittedFields } from './PaymentSubmittedFields'
import { PaidEscalationFields } from './PaidEscalationFields'
import { UnpaidEscalationFields } from './UnpaidEscalationFields'
import { BenefitEndDateFields } from './BenefitEndDateFields'
import { ContactEvidenceFields } from './ContactEvidenceFields'
import { TicketEvidenceFields } from './TicketEvidenceFields'

interface StatusFieldsProps {
  status?: PaymentStatus
  rolePolicy: PaymentAssignmentRolePolicy
  primaryPaymentMethod?: string
}

export function StatusFields({
  status,
  rolePolicy,
  primaryPaymentMethod,
}: StatusFieldsProps) {
  const didMakePayment = Form.useWatch(StatusUpdateFormKey.DID_MAKE_PAYMENT)
  const showContactEvidenceFields = rolePolicy.showContactEvidence ? (
    <ContactEvidenceFields />
  ) : null
  const showTicketEvidenceFields = rolePolicy.showTicketEvidence ? (
    <TicketEvidenceFields />
  ) : null
  switch (status) {
    case PaymentAssignmentStatusId.PAYMENT_SUBMITTED:
      return (
        <PaymentSubmittedFields primaryPaymentMethod={primaryPaymentMethod} />
      )
    case PaymentAssignmentStatusId.PAID_ESCALATION:
      return (
        <PaidEscalationFields primaryPaymentMethod={primaryPaymentMethod} />
      )
    case PaymentAssignmentStatusId.UNPAID_ESCALATION:
      return <UnpaidEscalationFields />
    case PaymentAssignmentStatusId.ESCALATION_FULLY_RESOLVED:
      return (
        <>
          {showContactEvidenceFields}
          <div style={{ marginTop: 16 }}>
            <Form.Item
              name={StatusUpdateFormKey.DID_MAKE_PAYMENT}
              valuePropName="checked"
              style={{ marginBottom: 0 }}
            >
              <Checkbox>
                {
                  StatusUpdateFormKeyLabels[
                    StatusUpdateFormKey.DID_MAKE_PAYMENT
                  ]
                }
              </Checkbox>
            </Form.Item>
          </div>
          {didMakePayment && (
            <PaymentSubmittedFields
              primaryPaymentMethod={primaryPaymentMethod}
            />
          )}
        </>
      )
    case PaymentAssignmentStatusId.EE_PAID:
      return showContactEvidenceFields ?? showTicketEvidenceFields
    case PaymentAssignmentStatusId.TERMINATED_EE:
      return showContactEvidenceFields
    case PaymentAssignmentStatusId.TERMINATED_PLAN:
      return (
        <>
          {showContactEvidenceFields ?? showTicketEvidenceFields}
          <BenefitEndDateFields />
        </>
      )
    case PaymentAssignmentStatusId.NEW_EFFECTIVE_DATE:
      return showTicketEvidenceFields ?? <ContactEvidenceFields />
    case PaymentAssignmentStatusId.CARRIER_SHOW_PAYMENT:
      return showTicketEvidenceFields ?? <ContactEvidenceFields />
    default:
      return null
  }
}
